import $ from 'jquery';
import React, { PropTypes } from 'react';
import ReactDOMServer from 'react-dom/server';
import { getCustomersWithoutContact } from './api';

// import Cookies from 'js-cookie';

// const COOKIES_STORE_KEY = 'liphatech.confirm';

export default function bind() {}

const content = names => {
  if (names.length === 1) {
    return `Attention, le client ${names[0]} n'a pas de mail de contact. Il ne recevra donc pas le compte rendu.`;
  } else {
    return `Attention, les clients ${names.join(
      ', '
    )} n'ont pas de mail de contact. Ils ne recevront donc pas le compte rendu.`;
  }
};

export const displayConfirmModalIfNeeded = (ids, callback) => {
  const title = 'Confirmation';
  const confirmationContent =
    "La validation du bilan va entraîner la génération du compte rendu d'intervention qui sera envoyé à votre client. Cette action est irréversible.";

  const renderActions = (
    <div className="actions">
      <div className="ui approve primary button">Valider</div>
      <div className="ui cancel button">Annuler</div>
    </div>
  );

  if (ids && ids.length > 0) {
    getCustomersWithoutContact(ids).then(response => {
      const { status, body } = response;
      if (body && status === 202) {
        callback();
      } else if (body && body.length > 0) {
        const modalContent =
          confirmationContent +
          '<br /><br />' +
          `<p style="color: red;">${content(body)}</p>`;
        displayConfirmModal(title, modalContent, renderActions, callback);
      } else {
        const modalContent = confirmationContent;
        displayConfirmModal(title, modalContent, renderActions, callback);
      }
    });
  } else {
    callback();
  }
};

function displayConfirmModal(title, content, actions, callback) {
  // Display modal
  const modal = ReactDOMServer.renderToStaticMarkup(
    <ConfirmModal title={title} content={content} actions={actions} />
  );
  displayModal(modal, callback);
}

export function displayCancelModal(callback) {
  const title = "Annuler l'intervention";
  const content = "Êtes-vous sûr(e) de vouloir annuler l'intervention ?";

  const renderActions = (
    <div className="actions">
      <div className="ui cancel button">Retour</div>
      <div className="ui approve red button">Annuler l'intervention</div>
    </div>
  );
  const modal = ReactDOMServer.renderToStaticMarkup(
    <ConfirmModal
      title={title}
      content={content}
      haveWarningIcon={false}
      actions={renderActions}
    />
  );

  displayModal(modal, callback);
}

export function displayCloseCaseModal(callback) {
  const title = 'Clôture immédiate';
  const content = 'Êtes-vous sûr(e) de vouloir clôturer le chantier ?';

  const renderActions = (
    <div className="actions">
      <div className="ui cancel button">Retour</div>
      <div className="ui approve red button">Clôturer le chantier</div>
    </div>
  );
  const modal = ReactDOMServer.renderToStaticMarkup(
    <ConfirmModal
      title={title}
      content={content}
      haveWarningIcon={false}
      actions={renderActions}
    />
  );

  displayModal(modal, callback);
}

function displayModal(modal, callback) {
  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#confirm-action-modal');

  $modal
    .modal({
      onApprove: element => {
        // Execute action and hiding it on executed
        callback();

        return true;
      },
    })
    .modal('show');
}

const ConfirmModal = ({ title, content, haveWarningIcon = true, actions }) => {
  const renderActions = actions ? (
    actions
  ) : (
    <div className="actions">
      <div className="ui primary approve button">Confirmer</div>
      <div className="ui cancel button">Annuler</div>
    </div>
  );
  return (
    <div id="confirm-action-modal" className="ui small modal">
      <div className="header">
        {haveWarningIcon && <i className="icon warning circle" />}
        {title}
      </div>
      <div className="content" style={{ marginBottom: '20px' }}>
        <p dangerouslySetInnerHTML={{ __html: content }} />
      </div>
      {renderActions}
    </div>
  );
};

ConfirmModal.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  haveWarningIcon: PropTypes.bool,
  actions: PropTypes.element,
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/validation/confirm-validation.js